import {lazyComponent} from 'coreUtils/adapters/lazy';

const CountrySelectorFlyout = lazyComponent(() => import('./CountrySelectorFlyout'));

export {CountrySelectorFlyout as default};
